import {
    apiConstants,
    config,
    downloadBlob,
    requestOptions,
    requestTypes,
    sendRequest,
} from "../../Utilities/Api";

//************************************************** STANDARD API SERVER CALLS ****************************************

class serverQueueApi {
    static addToQueue(catalogFormatId: string) {
        return sendRequest(
            requestOptions(config.URL + `queue`,
                requestTypes.POST,
                JSON.stringify({catalogFormatId}),
                apiConstants.successMessage.queue.ADD,
            ),
        );
    }

    static ValidateDuplicateTextbookQueueItemsForStudent(studentQueueViewModel: Record<string, unknown>) {
        return sendRequest(
            requestOptions(config.URL + `queue/validate-duplicates`,
                requestTypes.POST,
                JSON.stringify(studentQueueViewModel),
            ),
        );
    }

    static assignQueueItems(studentQueueViewModel: Record<string, unknown>) {
        return sendRequest(
            requestOptions(config.URL + `queue`,
                requestTypes.PUT,
                JSON.stringify(studentQueueViewModel),
                apiConstants.successMessage.queue.UPDATE,
            ),
        );
    }

    static removeFromQueue(queueItemId: string) {
        return sendRequest(
            requestOptions(config.URL + `queue/${queueItemId}`,
                requestTypes.DELETE,
                null,
                apiConstants.successMessage.queue.DELETE,
            ),
        );
    }

    static getQueue(systemType: string | number) {
        return sendRequest(
            requestOptions(config.URL + `queue/${systemType}`,
                requestTypes.GET,
            ),
        );
    }

    static getPendingTextbookQueueReport() {
        return downloadBlob(
            requestOptions(
                config.URL + `queue/pending/export`,
                requestTypes.GET,
                null,
                apiConstants.successMessage.report.REPORT_DOWNLOADED,
            ),
        );
    }
}

export const libraryQueueApi = config.environment.MODE === config.modes.SERVER ? serverQueueApi : serverQueueApi;
